import React, { useContext } from "react";
import { Grid, Box, Checkbox } from "@material-ui/core";
import Owner from "../../DocsFunding/Summary/Owner";
import EditIcon from "@material-ui/icons/Edit";
import Applicant from "../../DocsFunding/Summary/Applicant";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import ApplicantEdit from "../../DocsFunding/Summary/ApplicantEdit";
import Guarantor from "../../DocsFunding/Summary/Guarantor";
import Deal from "../../DocsFunding/Summary/Deal";
import UseStyles from "./UseStyles";
import IconButton from "@material-ui/core/IconButton";
import Assets from "../AssetsDoc";
import AlertPopUP from "../../AlertBox/AlertPopUp";
import SummaryContext from "../../DocsFunding/Summary/SummaryContext";

const SummaryCombinedAll = () => {
  const classes = UseStyles();
  const contextFun = useContext(SummaryContext);

  return (
    <Box className={classes.box_design} p={1}>
      <Grid container>
        {contextFun.app.status === "Funded" ||
          contextFun.app.status === "Pre_Booked" ||
          contextFun.app.status === "Booked" ? (
          <Grid item className={classes.headGrid_space} xs={12} align="right">
            <span
              className={classes.fundedDealText}
              style={{
                width: "20%",
                background: "#e4ecff",
              }}
            >
              Modify App number {<Checkbox
                disabled={contextFun.isReadOnly}
                checked={contextFun.applicantDataList?.add_ending_d === 'Yes' ? true : false}
                onChange={(e) => contextFun.onModifyClicked(e.target.checked)}
              />}
            </span>
          </Grid>
        ) : null}
        {(contextFun.app.status === "Document Check In" || contextFun.app.status === "Funding") &&
          contextFun.app !== null ? (
          <Grid item className={classes.headGrid_space} xs={12} align="right">
            <span
              className={classes.fundedDealText}
              style={{
                width: "20%",
                background: "#ede2da",
              }}
            >
              Skip Verbal DnA {<Checkbox
                disabled={contextFun.isReadOnly}
                checked={contextFun.applicantDataList?.skip_verbal_dna}
                onChange={(e) => contextFun.onSkipVerbalClicked(e.target.checked)}
              />}
            </span>
          </Grid>
        ) : null}
        {contextFun.applicantDataList &&
          Object.keys(contextFun.applicantDataList).length ? (
          <Grid item className={classes.headGrid_space} xs={12} align="right">
            <span
              className={classes.fundedDealText}
              style={{
                width: "20%",
                background: "#e4ecff",
              }}
            >
              Pre funded Deal{" "}
              {
                <Checkbox disabled={contextFun.isReadOnly}
                  checked={contextFun.applicantDataList?.is_fifty_pre_funded}
                  onChange={(e) => contextFun.onFiftyClicked(e.target.checked)}
                />
              }
            </span>
          </Grid>
        ) : null}
        {
          contextFun.ownerData?.currentState !== 0 &&
          <>
            <Grid className={classes.grid_space} align="left" item xs={12}>
              <span className={classes.headerText}>Owner</span>
            </Grid>

            <Grid className={classes.containerShadow} item xs={12}>
              <Owner ownerInfo={contextFun.ownerData} />
            </Grid>
          </>
        }

        <Grid className={classes.grid_space} item xs={12}>
          <Box component="div" className={classes.applicantHead}>
            <span className={classes.headerTextApplicant}>Applicant</span>
            {!contextFun.isReadOnly && (
              <span>
                {contextFun.isShow ? (
                  <span>
                    <IconButton
                      color="secondary"
                      aria-label="upload picture"
                      component="span"
                      onClick={contextFun.applicationEdit}
                    >
                      <CloseOutlinedIcon
                        className={classes.applicantIcon}
                        style={{
                          backgroundColor: "red",
                          color: "white",
                        }}
                      />
                    </IconButton>
                  </span>
                ) : (
                  <IconButton
                    color="secondary"
                    aria-label="upload picture"
                    component="span"
                    onClick={contextFun.applicationEdit}
                  >
                    <EditIcon
                      className={classes.applicantIcon}
                      style={{
                        backgroundColor: "#303F9F",
                        color: "white",
                      }}
                    />
                  </IconButton>
                )}
              </span>
            )}
          </Box>
        </Grid>
        {contextFun.alertModal.open &&
          <Grid className={classes.containerShadow} item xs={12}>
            <AlertPopUP
              open={contextFun.alertModal.open}
              severity={contextFun.alertModal.status}
              message={contextFun.alertModal.message}
            />
          </Grid>
        }
        <Grid className={classes.containerShadow} item xs={12}>
          {contextFun.isShow ? (
            <ApplicantEdit />
          ) : (
            <Applicant
              ApplicantData={contextFun.applicantDataList}
              assetType={contextFun.assetType}
            />
          )}
        </Grid>
        <Grid className={classes.grid_space} item xs={12} align="left">
          <span className={classes.headerText}>Guarantors</span>
        </Grid>
        <Grid className={classes.containerShadow} item xs={12}>
          <Guarantor guarantorData={contextFun.guarantorDataList} originalGuarantors={contextFun.originalGuarantors} isReadOnly={contextFun.isReadOnly} />
        </Grid>
        <Grid className={classes.grid_space} item xs={12} align="left">
          <span className={classes.headerText}>Assets</span>
        </Grid>
        <Grid className={classes.containerShadow} item xs={12}>
          <Assets app={contextFun.app} isReadOnly={true} />
        </Grid>
        {
          contextFun.dealDataList && contextFun.dealDataList?.length > 0 &&
          <>
            <Grid className={classes.grid_space} item xs={12} align="left">
              <span className={classes.headerText}>Deals</span>
            </Grid>

            <Grid className={classes.containerShadow} item xs={12}>
              <Deal dealData={contextFun.dealDataList} />
            </Grid>
          </>
        }
      </Grid>
    </Box>
  );
};

export default SummaryCombinedAll;
